<div class="grid form-group">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <div *ngIf="!save">
      <p-pickList [source]="listaOcupaciones" [target]="ocupacionesSeleccionadas"
                  sourceHeader="{{'SEGMENTOSOCUPACIONES.LBL_OCUPACIONESDISPONIBLES'|translate}}"
                  targetHeader="{{'SEGMENTOSOCUPACIONES.LBL_OCUPACIONESSELECCIONADAS'|translate}}"
                  (onMoveToTarget)="guardar($event.items, true)"
                  (onMoveToSource)="guardar($event.items, false)"
                  [showTargetControls]="false"
                  [showSourceControls]="false"
                  filterBy="ocupacion">
        <ng-template let-ocupacion pTemplate="item">
          <div class="p-helper-clearfix">
            {{ocupacion.codigoOcupacion}}-{{ocupacion.ocupacion}}
          </div>
        </ng-template>
      </p-pickList>
    </div>
    <div *ngIf="save">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
      <span>{{'LBL_GUARDANDO' | translate }}</span>
    </div>
  </div>

</div>

